import * as Yup from "yup";

export default () =>
  Yup.object().shape({
    email: Yup.string("Debe ser un texto")
      .required("Campo requerido")
      .email("Ingresa un email válido"),
  });
